import React from 'react'

import MyCheckbox from './UI/MyCheckbox'

const CheckboxQuestion = ({ input, checkboxOnChange, inputOnChange }) => {
    const { id, text, addedText, variants, max, value, withInput } = input

    return (
        <div className="checkbox-container">
            <p className="_question-text">{id + 1}. {text}</p>

            <p className="">{addedText ? addedText : ''}</p>

            <ul className="checkbox-question__list">
                {
                    variants.map(variant => (
                        <li key={variant.id}>
                            <MyCheckbox questionId={id} variantId={variant.id} text={variant.text} max={max} value={value} onChange={checkboxOnChange} />
                        </li>
                    ))
                }
            </ul>

            {
                withInput ?

                    <input className='my-bottom-input my-bottom-input_without-margin' type="text" placeholder='Свой вариант' value={value[variants.length]} onChange={(evt) => inputOnChange(id, variants.length, evt.target.value)} />

                :

                    ''
            }
        </div>
    )
}

export default React.memo(CheckboxQuestion)